/*
 * Nav directive
 * Version 1.0.0
 * Octave
 * Modified from <https://github.com/dpiccone/ng-pageslide>.
 **/

(function () {
  'use strict';

  angular
    .module('main.nav', [])

    /* @ngInject */
    .directive('rbMainNav', function () {
      var directive = {
        restrict: 'A',
        bindToController: true,
        controller: function () {
          var ctrl = this;

          ctrl.open = false;
          ctrl.children = [];

          ctrl.toggle = function () {
            ctrl.open = !ctrl.open;
            var i, len = ctrl.children.length;
            for (i = 0; i < len; i++) {
              ctrl.children[i].open = false;
            }
          };
        },
        controllerAs: 'mainNavCtrl'
      };
      return directive;
    })

    /* @ngInject */
    .directive('rbNav', ["$document", "$animate", function ($document, $animate) {
      var directive = {
        restrict: 'A',
        scope: {
          psOpen: '=?'
        },
        link: link
      };
      return directive;

      function link(scope, element) {

        element.addClass('ng-pageslide');

        // DOM manipulation

        var slider, body, $body;

        body = document.body;
        $body = $(body);

        function onBodyClick(e) {
          if (scope.psOpen && !slider.contains(e.target)) {
            scope.$apply(function () {
              scope.psOpen = false;
            });
          }
        }

        $body.addClass('offcanvas');

        slider = element[0];

        if (slider.children.length === 0) {
          throw new Error('You need to have content inside the <pageslide>');
        }

        // Closed
        function psClose() {
          if ($body.hasClass('offcanvas-left')) {
            $('.move-out').removeClass('move-out'); // TODO
            $animate.removeClass(body, 'offcanvas-left').then(closeDone);
            $document.off('click', onBodyClick);
          }
        }
        function closeDone() {
          scope.psOpen = false;
        }
        // Open
        function psOpen() {
          if (!$body.hasClass('offcanvas-left')) {
            $animate.addClass(body, 'offcanvas-left').then(openDone);
            $document.on('click', onBodyClick);
          }
        }
        function openDone() {
          scope.psOpen = true;
        }

        // Watchers
        scope.$watch('psOpen', function (value) {
          if (!!value) {
            psOpen();
          } else {
            psClose();
          }
        });

        // Events

        scope.$on('$destroy', function () {
          if (slider.parentNode === body) {
            $document.off('click', onBodyClick);
          }
        });

        scope.$on('$locationChangeStart', function () {
          psClose();
        });
      }

    }])

    /* @ngInject */
    .directive('rbMenu', ["$animate", "$injector", "$location", function ($animate, $injector, $location) {
      var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
      var directive = {
        restrict: 'A',
        scope: true,
        link: link
      };

      return directive;

      function link(scope, element) {

        scope.mainNavCtrl.children.push(scope);
        //
        scope.open = false;
        scope.element = element;

        initMenu();
        initLevelsLinks();

        scope.expandMenu = function () {
          var $menu = element.children('.menu');
          element.children('a').addClass('in');

          $menu.addClass('collapsing')
            .attr('aria-expanded', true)
            .attr('aria-hidden', false);

          if (scope.device.isTouch && !scope.device.desktop ) {
            $menu.after('<div class="backdrop"/>');
            element.children('.backdrop').on('click', function () {
              $(this).remove();
              scope.reduceMenu();
            });
          }

          function expandDone() {
            $menu.removeClass('collapsing')
              .css({height: 'auto'});
          }

          if ($animateCss) {
            $animateCss($menu, {
              addClass: 'in',
              easing: 'ease',
              to: { height: $menu[0].scrollHeight + 'px' }
            }).start().finally(expandDone);
          } else {
            $animate.addClass($menu, 'in', {
              to: { height: $menu[0].scrollHeight + 'px' }
            }).then(expandDone);
          }
        };

        scope.reduceMenu = function () {

          

          var $menu = element.children('.menu');
          if (!$menu.length) return;

          

          element.children('a').removeClass('in');
          element.children('.backdrop').remove();

          $menu.css({height: $menu[0].scrollHeight + 'px'})
            .addClass('collapsing')
            .attr('aria-expanded', false)
            .attr('aria-hidden', true);

          function collapseDone() {
            $menu.css({height: '0'})
              .removeClass('collapsing');
          }

          if ($animateCss) {
            $animateCss($menu, {
              removeClass: 'in',
              to: {height: '0'}
            }).start().finally(collapseDone);
          } else {
            $animate.removeClass($menu, 'in', {
              to: {height: '0'}
            }).then(collapseDone);
          }
        };

        scope.openMenu = function (event) {
          event.preventDefault();

          if (!scope.device.desktop) {
            scope.open = !scope.open;
            element
              .siblings().addClass('move-out').end()
              .closest('.nav').scrollTop(0);
          } else {

            if (element.hasClass('level1')) {
              var $menu = element.children('.menu');
              if (!$menu.hasClass('collapsing') && !$menu.hasClass('in')) {
                var ctrl = scope.mainNavCtrl,
                  i, len = ctrl.children.length;
                for (i = 0; i < len; i++) {
                  if (ctrl.children[i].element !== element && ctrl.children[i].element.children('.menu.in').length) {
                    ctrl.children[i].reduceMenu();
                  }
                }
                scope.expandMenu();
                return;
              }
              scope.reduceMenu();
            }
            $location.path(element.children('a').attr('href'));

          }
        };

        scope.backMenu = function (event) {
          event.preventDefault();
          scope.open = !scope.open;
          element.siblings().removeClass('move-out');
        };

        scope.closeMenu = function () {
          scope.mainNavCtrl.open = false;
        };

        // Functions

        function initMenu() {


          if (scope.device.isTouch || !scope.device.desktop || !element.hasClass('level1')) return;

          hoverintent(element[0],
            function () {
              scope.expandMenu();
            },
            function () {
              scope.reduceMenu();
            }).options({
              timeout: 200,
              interval: 100
            });
        }
        function initLevelsLinks() {
          element.on('click', 'a', function (event) {
            if (scope.device.desktop && !scope.device.isTouch) {
              scope.reduceMenu();
            }

            if (scope.device.desktop && scope.device.isTouch && !element.hasClass('level1')) {              
              $('#navMenu').find('.level1').children('a').removeClass('in');
              $('#navMenu').find('.level1').children('.menu').removeClass('in');             
            }

          });
        }

      }

    }]);

})();
